import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { HandleActivitiesAnalyticalPerGroupUseCaseInterface } from 'domain/usecases';
import { IActivitiesAnalyticalPerGroupFilters } from 'presentation/app/modules/Reports/models/activities-analytical-per-group-filters';

interface IActivitiesAnalyticalPerGroup {
  groupsListData: HandleActivitiesAnalyticalPerGroupUseCaseInterface.Result;
  filters: IActivitiesAnalyticalPerGroupFilters;
}

interface IPayloadGroupsListData
  extends PayloadAction<HandleActivitiesAnalyticalPerGroupUseCaseInterface.Result> {}

interface IPayloadFilters
  extends PayloadAction<IActivitiesAnalyticalPerGroupFilters> {}

const initialState: IActivitiesAnalyticalPerGroup = {
  groupsListData: [],
  filters: null,
};

export const ActivitiesAnalyticalPerGroupSlice = createSlice({
  name: 'activity-report-internship',
  initialState,
  reducers: {
    loadGroupsListData: (state, action: IPayloadGroupsListData) => {
      state.groupsListData = action.payload;
    },
    clearGroupsListData: (state) => {
      state.groupsListData = [];
    },
    loadFilters: (state, action: IPayloadFilters) => {
      state.filters = action.payload;
    },
    clearFilters: (state) => {
      state.filters = null;
    },
  },
});

export const {
  loadGroupsListData,
  clearGroupsListData,
  loadFilters,
  clearFilters,
} = ActivitiesAnalyticalPerGroupSlice.actions;

export default ActivitiesAnalyticalPerGroupSlice.reducer;
